<template>
  <div>
    <div class="row ts-flex ts-space-y-2 ts-items-center">
      <div class="col-md-4 ts-mt-2" v-if="enableAccount">
        <label class="required ts-mb-0">{{
          $t('productProfile.account')
        }}</label>
        <Select
          v-model.number="model.account_id"
          :filter-by-label="true"
          :placeholder="$t('select')"
          :clearable="true"
          filterable
          @on-query-change="handleSearch"
        >
          <Option
            v-for="item in accounts"
            :value="item.account_id"
            :key="item.account_id"
            :label="item.account_name_en"
          >
            {{ item.account_number + '-' + item.account_name_en }}
          </Option>
        </Select>
        <div class="validate" v-if="errors.has('account_id')">
          {{ errors.first('account_id') }}
        </div>
      </div>
      <div class="col-md-4" :class="{ 'ts-mt-2': !enableAccount }">
        <label class="required ts-mb-0">{{
          $t('productProfile.category')
        }}</label>
        <a-select
          v-model.number="model.category_id"
          :options="productCategory"
          class="ts-w-full"
          @change="getBarcode"
          showSearch
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          :disabled="is_disabled"
        ></a-select>
        <div class="validate" v-if="errors.has('category_id')">
          {{ errors.first('category_id') }}
        </div>
      </div>
      <div class="col-md-4">
        <label class="ts-mb-0">{{ $t('productProfile.group') }}</label>
        <div>
          <a-select
            class="ts-w-full"
            v-model.number="model.pro_group_id"
            :options="groupList"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('pro_group_id')">
            {{ errors.first('pro_group_id') }}
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <label class="ts-mb-0">{{ $t('productProfile.nameKh') }}</label>
        <div>
          <input
            v-model.trim="model.product_name_kh"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('product_name_kh')">
            {{ errors.first('product_name_kh') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="required ts-mb-0">{{
          $t('productProfile.nameEn')
        }}</label>
        <div>
          <input
            v-model.trim="model.product_name_en"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('product_name_en')">
            {{ errors.first('product_name_en') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="required ts-mb-0">{{ $t('productProfile.mode') }}</label>
        <div>
          <a-select
            v-model.number="model.product_mode_id"
            :options="productMode"
            class="ts-w-full"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('product_mode_id')">
            {{ errors.first('product_mode_id') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="ts-mb-0 required">{{
          $t('productProfile.productType')
        }}</label>
        <div>
          <a-select
            v-model.number="model.product_type_id"
            :options="productType"
            class="ts-w-full"
            @change="fetchRecipe"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('product_type_id')">
            {{ errors.first('product_type_id') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="ts-mb-0 required">{{
          $t('productProfile.barcode')
        }}</label>
        <div>
          <input
            v-model.trim="model.barcode"
            type="text"
            class="form-control"
          />
          <div class="validate" v-if="errors.has('barcode')">
            {{ errors.first('barcode') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="required ts-mb-0">{{
          $t('productProfile.uomCategory')
        }}</label>
        <div>
          <a-select
            class="ts-w-full"
            v-model.number="model.uom_cat_id"
            :options="uomCategory"
            :disabled="notAllowChange || is_disabled"
            @change="getSalecode"
            showSearch
            :filterOption="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
          ></a-select>
          <div class="validate" v-if="errors.has('uom_cat_id')">
            {{ errors.first('uom_cat_id') }}
          </div>
        </div>
      </div>
      <div class="col-md-4 ts-mt-2">
        <label class="ts-mb-0 control-label">{{
          $t('productProfile.orderAllow')
        }}</label>
        <div>
          <div class="ts-space-x-4 ts-flex">
            <input
              v-model.number="model.minimum_reorder_qty"
              type="number"
              class="ts-w-1/2 ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
              :class="{
                'ts-border-red-600': errors.has('minimum_reorder_qty')
              }"
              :placeholder="$t('productProfile.minimum')"
            />
            <input
              v-model.number="model.maximum_reorder_allow"
              type="number"
              class="ts-w-1/2 ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
              :class="{
                'ts-border-red-600': errors.has('maximum_reorder_allow')
              }"
              :placeholder="$t('productProfile.maximum')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="ts-border ts-order-1 ts-rounded ts-flex ts-items-center ts-space-x-3 ts-px-3 ts-py-1 ts-pb-2 ts-mt-3"
        >
          <ts-checkbox v-model="model.is_expirable">
            {{ $t('productProfile.isExpirable') }}
          </ts-checkbox>
          <ts-checkbox v-model="model.is_feature">
            {{ $t('productProfile.isFeature') }}
          </ts-checkbox>
          <ts-checkbox v-model="model.vat_eligible">
            {{ $t('productProfile.vatEligible') }}
          </ts-checkbox>
          <ts-checkbox v-model="model.is_generate_unique_serial">
            {{ $t('productProfile.generateUniqueSerial') }}
          </ts-checkbox>
        </div>
      </div>
    </div>
    <form class="form-horizontal ts-space-y-4">
      <!-- <div class="row">
        <label class="col-md-4 form-col-label control-label required">{{$t('productProfile.ageEligible')}}</label>
        <div class="col-md-8 ts-space-x-4 ts-flex">
          <input
						v-model.number="model.age_eligible_from" 
						type="number" class="ts-w-1/2 ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
						:class="{ 'ts-border-red-600': errors.has('age_eligible_from') }"
						:placeholder="$t('productProfile.from')"
					>
          <input 
						v-model.number="model.age_eligible_to"
						type="number" 
						class="ts-w-1/2 ts-border ts-border-gray-400 ts-rounded-md ts-px-3 ts-py-2 ts-outline-none"
						:class="{ 'ts-border-red-600': errors.has('age_eligible_to') }"
						:placeholder="$t('productProfile.to')"
					>
        </div>
      </div> -->
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import { isEmpty, debounce } from 'lodash'

export default {
  name: 'productInfo',
  props: ['value', 'validate'],
  data() {
    return {
      errors: new Errors(),
      model: {},
      is_disabled: false,
      searching: false,
      accounts: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    enableAccount() {
      return this.$store.state.product.profile.setting.is_accounting
    },
    isEdit() {
      return !isEmpty(this.$store.state.product.profile.edit_data)
    },
    productType() {
      return this.$store.state.product.profile.productTypes.map(el => ({
        value: el.product_type_id,
        label: el.product_type_en
      }))
    },
    productCategory() {
      return this.$store.state.product.profile.productCategories.map(el => ({
        value: el.category_id,
        label: el.category_name_en
      }))
    },
    productMode() {
      return this.$store.state.product.profile.productMode.map(el => ({
        value: el.product_mode_id,
        label: el.product_mode
      }))
    },
    uomCategory() {
      return this.$store.state.product.profile.uomCategories.map(el => ({
        value: el.uom_cat_id,
        label: el.uom_cat_name_en
      }))
    },
    groupList() {
      return this.$store.state.product.profile.groups
        .filter(g => g.category_id == this.model.category_id)
        .map(el => ({
          value: el.pro_group_id,
          label: el.pro_group_name_en
        }))
    },
    notAllowChange() {
      return this.model.barcode == null || this.model.barcode == ''
    },
    notForWholesale() {
      return !this.$store.state.authUser.sys_setting.is_whole_sale
    }
  },
  methods: {
    ...mapActions('product/profile', [
      'barcode',
      'salecode',
      'recipe',
      'allowChangUomCat',
      'formViewModel'
    ]),
    getBarcode(value) {
      this.$emit('loading', true)
      this.model.pro_group_id = null
      this.model.product_sale_code = []
      this.model.uom_cat_id = null
      this.barcode(value)
        .then(response => {
          this.model.barcode = response.data
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    getSalecode() {
      this.$emit('loading', true)
      if (!this.model.product_id) {
        this.model.product_sale_code = []
      }
      this.salecode({
        uom_cat_id: this.model.uom_cat_id,
        product_id: this.model.product_id,
        product_barcode: this.model.barcode,
        product_type_id: this.model.product_type_id
      })
        .then(response => {
          this.createSalecodeRecord(response.data)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    fetchRecipe() {
      if (this.model.product_type_id != 3) {
        this.$emit('loading', true)
        this.recipe().finally(() => {
          this.$emit('loading', false)
        })
      } else {
        this.$store.commit('product/profile/SET_RECIPE_LIST', [])
        this.model.recipes = []
      }
    },
    createSalecodeRecord(data) {
      this.model.product_sale_code = []
      this.model.product_sale_code = Object.assign({}, data)
      this.$forceUpdate()
    },
    allowChangeUomCheck() {
      this.$emit('loading', true)
      this.allowChangUomCat(this.model.product_id)
        .then(response => {
          this.is_disabled = !response.data.status
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    handleSearch: debounce(function(value) {
      this.loading = true
      this.formViewModel({
        fnName: 'account',
        search: value
      })
        .then(response => {
          this.accounts = response.data.account
        })
        .finally(() => (this.loading = false))
    }, 800)
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    'model.product_id': function(id) {
      if (id) {
        this.getSalecode()
        this.allowChangeUomCheck()
      }
    }
  }
}
</script>
